import LayoutMain from 'components/LayoutComponents/Main';
import { LayoutNavbar } from 'components/LayoutComponents/Navbar';
import useAuth from 'hooks/useAuth';
import NotFoundPage from 'pages/NotFoundPage';
import { FC, ReactNode } from 'react';
import { Route } from 'react-router-dom';
import loadableRoutes from './loadableRoutes';
import { ConnectedSwitch } from './reactRouterConnected';

const ConnectedSwitchComponent = ConnectedSwitch as unknown as FC<{ children?: ReactNode }>;

const WrapperComponent = ({ component: Component, ...props }) => {
  useAuth({
    requiredAuth: props.requiredAuth,
  });
  if (props.singlePage) {
    return <Component {...props} />;
  }

  return (
    <>
      <LayoutNavbar />
      <LayoutMain>
        <Component {...props} />
      </LayoutMain>
    </>
  );
};

const WrapperNotFoundComponent = () => {
  useAuth();
  return <NotFoundPage />;
};

const Routes: FC = () => (
  <ConnectedSwitchComponent>
    {Object.keys(loadableRoutes).map((path) => {
      const routeProps = loadableRoutes[path];
      return (
        <Route
          key={path}
          path={path}
          component={(props) => <WrapperComponent {...routeProps} {...props} />}
        />
      );
    })}
    <Route
      render={() => {
        return <WrapperNotFoundComponent />;
      }}
    />
  </ConnectedSwitchComponent>
);

export { loadableRoutes };
export default Routes;
